import { Directive, HostListener, Input, OnInit } from '@angular/core';

import { ActionContextMenu } from '../../models/action-context-menu.model';
import { ActionContextMenuService } from '../../services/action-context-menu.service';
import { DeviceDetector } from '../../services/device-detector.service';

@Directive({
    selector: '[ohpActionContextMenuTarget]'
})
export class ActionContextMenuTargetDirective implements OnInit {
    @Input('ohpActionContextMenuTarget') public model: ActionContextMenu;

    // Provides capability for host component to explicitly disable context menu, e.g. clicking on an icon opens up the same context menu
    // as right clicking on the entire item in MRU list. This will prevent duplicated menus from showing up.
    @Input('ohpActionContextMenuDisabled') public disabled: boolean;

    public desktop: boolean;

    constructor(
        private readonly actionContextMenuService: ActionContextMenuService,
        private readonly deviceDetector: DeviceDetector
    ) {
    }

    public ngOnInit() {
        this.desktop = this.deviceDetector.isDesktopDevice();
    }

    @HostListener('contextmenu', ['$event'])
    public onContextMenu(event: MouseEvent): void {
        if (!this.desktop || !this.model || !event || this.disabled) {
            return;
        }
        event.preventDefault();
        this.actionContextMenuService.openMenu({
            id: this.model.id,
            itemIndex: this.model.itemIndex,
            actions: this.model.actions,
            groupInfo: this.model.groupInfo,
            mouseEvent: event,
            targetElement: undefined
        });
    }
}
